import React, { Component } from 'react';
import { connect } from 'react-redux';

import { isAssigned, triggerAssignment } from 'actions/ab';
import { PageLoader } from 'components/Loader';
import CaapCheckout from 'containers/Checkout/Checkout';
import MelodyCheckout from 'containers/Checkout/MelodyCheckout';
import marketplace from 'cfg/marketplace.json';

const { checkout: { melodyHydraTest } } = marketplace;

export class CheckoutPicker extends Component {
  static webpackChunkName = 'Checkout';
  componentDidMount() {
    this.props.triggerAssignment(melodyHydraTest);
  }

  render() {
    const { isCaapCheckout, isMelodyCheckout, isMelodyCheckoutB } = this.props;

    if (!isCaapCheckout && !isMelodyCheckout && !isMelodyCheckoutB) {
      return <PageLoader />;
    }

    return isMelodyCheckout || isMelodyCheckoutB ? <MelodyCheckout /> : <CaapCheckout />;
  }
}

function mapStateToProps(state) {
  return {
    isCaapCheckout: isAssigned(melodyHydraTest, 0, state),
    isMelodyCheckout: isAssigned(melodyHydraTest, 1, state),
    isMelodyCheckoutB: isAssigned(melodyHydraTest, 2, state)
  };
}

export default connect(mapStateToProps, { triggerAssignment })(CheckoutPicker);
